import * as React from 'react';

import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import { VoiceboxPanelLink } from 'bones/components/molecules/Voicebox/panel/VoiceboxPanelLink';
import { VoiceboxPanelLoadMore } from 'bones/components/molecules/Voicebox/panel/VoiceboxPanelLoadMore';
import { PaginatedArray } from 'bones/constants/voicebox/panel';
import { Accordion } from 'bones/design-system/components/Accordion';
import { TableBody } from 'bones/design-system/components/data-table/TableBody';

export interface VoiceboxPanelInstancesProps {
  instances: PaginatedArray<string>;
  messageId: string;
}

export const VoiceboxPanelInstances: React.VFC<VoiceboxPanelInstancesProps> = ({
  instances,
  messageId,
}) => {
  const { copy, testIds } = useVoiceboxSchema();

  if (!instances.count) {
    return null;
  }

  return (
    <Accordion
      badgeProps={{ children: instances.count.toLocaleString() }}
      className="vb-voicebox-panel-instances"
      icon="left"
      initialIsOpen
      label={copy.panel.instances.accordion}
      size="md"
      testId={testIds.panel.instances.accordion}
    >
      <div className="vb-data-table">
        <TableBody
          body={[
            <td key="instances">
              <div>
                {instances.items.map((item, itemIdx) => (
                  <React.Fragment key={item}>
                    <VoiceboxPanelLink
                      iri={item}
                      messageId={messageId}
                      testId={testIds.panel.instances.link(item, itemIdx)}
                    />
                  </React.Fragment>
                ))}
              </div>
              <VoiceboxPanelLoadMore
                data={instances}
                testId={testIds.panel.instances.loadMore}
              />
            </td>,
          ]}
          header={<td>{copy.panel.instances.value}</td>}
          size="lg"
        />
      </div>
    </Accordion>
  );
};
